module.exports = __webpack_public_path__ + "imgcvh/hero-4.24d98891.jpg";